import(/* webpackMode: "eager", webpackExports: ["TeamRoot"] */ "/app/apps/web/src/app/(root)/[teamPermalink]/TeamRoot.tsx");
